import { constants } from '../features/Settings'
import { actionUsersForgetUsers, actionAppSetShowLoginState } from '../actions'

const LogoutMiddleware = store => next => (action) => {
    switch (action.type) {
        case constants.FORGET_ALL_USERS: {
            const result = next(action)
            store.dispatch(actionUsersForgetUsers())
            store.dispatch(actionAppSetShowLoginState(true))
            return result
        }

        default:
            return next(action)
    }
}

export default LogoutMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/LogoutMiddleware.js